/**
 * @Descripttion:
 * @Author: lks
 * @Date: 2021-09-30 15:06:35
 * @LastEditors: lks
 * @LastEditTime: 2021-11-03 10:06:30
 */
import http from "@/plugin/axios";
import { getSubName } from "@/utils/getHost";
export default {
  /**
   * 消息列表
   */
  getMessageList: (data: any): Promise<any> => {
    if (getSubName() == "longyixiu") {
      data.appletSource = 1;
    } else if (getSubName() == "wenjuanjia") {
      data.appletSource = 7;
    }
    return http.post("active/message/list", data);
  },
  /**
   * 信息数量
   */
  getListCount: (data: any): Promise<any> => {
    return http.post("active/message/listCount", data);
  },
  /**
   * 设置已读信息
   */
  getReadMessage: (data: any): Promise<any> => {
    return http.post("active/message/readMessage", data);
  },
  /**
   * 设置单个已读信息
   */
  getReadSingleMessage: (data: any): Promise<any> => {
    return http.post("active/message/readSingleMessage", data);
  },
};
